import React, { useCallback } from 'react'

import type { IAppTextProps } from 'components/AppText'
import RichText from 'components/AppText'
import type { IControlProps } from 'components/controls/Field/Field.types'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldRichText: React.FC<IControlProps<IAppTextProps>> = ({ onChange, name, ...rest }) => {
  const handleOnChange = useCallback(
    (value: IAppTextProps['value']) => onChange({ value, name }),
    [onChange, name],
  )

  return <RichText {...rest} name={name} onChange={handleOnChange} />
}

export default FieldRichText
